import {useEffect} from "react";

const useMautic = () => {
    useEffect(() => {
        // Check if the window object is defined and the environment is production
        if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
            (function (w, d, t, u, n, a, m) {
                w["MauticTrackingObject"] = n;
                w[n] = w[n] || function () {
                    (w[n].q = w[n].q || []).push(arguments);
                }, a = d.createElement(t),
                    m = d.getElementsByTagName(t)[0];
                a.async = 1;
                a.src = u;
                m.parentNode.insertBefore(a, m);
            })(window, document, "script", "https://mautic.althire.ai/mtc.js", "mt");

            window["mt"] && window["mt"]("send", "pageview");
        }
    }, []);
};
// This hook initializes Mautic tracking when the component mounts.
export default useMautic;
